<template>
  <div>
    <Breadtabsheader />
    <div class="h-content">
      <div class="h-piece">
        <el-form
          :inline="true"
          :model="q"
          class="demo-form-inline h-formBorder"
        >
          <div class="h-thirdColumn w-newColumn">
            <el-form-item label="用户单位">
              <el-input
                v-model="q.userUnitName"
                placeholder="请输入用户单位"
                :clearable="true"
              ></el-input>
            </el-form-item>
            <el-form-item label="省" prop="province">
              <el-select
                  v-model="q.province"
                  filterable
                  clearable
                  placeholder="省"
                  style="width: 80%"
              >
                <el-option
                    v-for="item in shenglist"
                    :key="item.value"
                    :label="item.name"
                    :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="渠道" prop="chanel">
              <el-select
                  v-model="q.channel"
                  clearable
                  placeholder="请选择"
                  style="width: 100%"
              >
                <el-option
                    v-for="item in qudaoList"
                    :key="item.code"
                    :label="item.name"
                    :value="item.name"
                >
                </el-option>
              </el-select>
            </el-form-item>
          </div>

          <div class="h-thirdColumn w-newColumn">
          </div>
        </el-form>
        <!----------------------------------- 展开搜素 ---------------------------------------------->
        <div class="l-screenBox">
          <div class="l-retrieval">
            <el-button class="h-btn h-formBtn" @click="selectPageAll"
              >检索</el-button
            >
            <el-button class="h-btn h-formBtn h-bgwhite" @click="rest"
              >重置</el-button
            >
          </div>
        </div>
      </div>
      <!-- 结果展示 -->
      <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
        <el-table
          ref="multipleTable"
          @selection-change="handleSelectionChange"
          :data="tableData"
          :border="true"
          stripe
          max-height="560"
          style="width: 100%"
        >
          <!-- <el-table-column type="selection" width="55"> </el-table-column> -->
          <el-table-column prop="q1Target" label="目标用户">
          <el-table-column label="序号" type="index" fixed width="50">
          </el-table-column>
            <el-table-column
                prop="channel"
                label="渠道"
                width="90"
            ></el-table-column>
          <el-table-column
            prop="province"
            label="省份"
            width="90"
          ></el-table-column>
          <el-table-column
            prop="city"
            label="地市"
            width="90"
          ></el-table-column>
            <el-table-column prop="userUnitName" label="用户单位" width="140" :show-overflow-tooltip="true">
              <template scope="scope">
                <div style="text-align: left">
                  {{ scope.row.userUnitName }}
                </div>
              </template>
            </el-table-column>
          <el-table-column
              prop="type"
              label="分类"
              width="90"
          ></el-table-column>
          <el-table-column
              prop="attribute"
              label="属性"
              width="90"
          ></el-table-column>
          </el-table-column>
          <el-table-column prop="q1Target" label="累计销售金额">
            <el-table-column
                prop="lianqunall"
                label="小计"
                width="90"
            ></el-table-column>
          <el-table-column
              prop="yangben"
              label="样本网"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="yaopin"
              label="药品网"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="yunyan"
              label="云眼网"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="peiyangxiang"
              label="培养箱"
              width="90"
          ></el-table-column>

            <el-table-column
                prop="lixinji"
                label="离心机"
                width="90"
            ></el-table-column>

            <el-table-column
                prop="xueye"
                label="血液"
                width="90"
            ></el-table-column>

            <el-table-column
                prop="yimiao"
                label="疫苗"
                width="90"
            ></el-table-column>

          </el-table-column>
          <el-table-column prop="q1Target" label="年度销售">

          <el-table-column
              prop="year2020"
              label="20年"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="year2021"
              label="21年"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="year2022"
              label="22年"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="year2023"
              label="23年"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="year2024"
              label="24年"
              width="90"
          ></el-table-column>
            <el-table-column
                    prop="year2025"
                    label="25年"
                    width="90"
            ></el-table-column>
            <el-table-column
                prop="yearall"
                label="年累计"
                width="90"
            ></el-table-column>
          </el-table-column>

          <el-table-column prop="q1Target" label="漏斗信息">
            <el-table-column
                prop="loudCount"
                label="漏斗数量"
                width="120"
            >
              <template slot-scope="scope">
                <div>
                  <el-button type="text" @click="lookDetailLoud(scope.row)">{{
                      scope.row.loudCount
                    }}</el-button>
                </div>
              </template>
            </el-table-column>

            <el-table-column
                prop="loudPrice"
                label="漏斗金额"
                width="90"
            ></el-table-column>

          </el-table-column>

          <el-table-column prop="zhaobiao" label="招标信息">
            <el-table-column
                prop="bidCount"
                label="中标条数"
                width="120"
            >
              <template slot-scope="scope">
                <div>
                  <el-button type="text" @click="lookDetailBid(scope.row,'中标')">{{
                      scope.row.bidCount
                    }}</el-button>
                </div>
              </template>
            </el-table-column>

            <el-table-column
                prop="bidLimit"
                label="中标额度"
                width="90"
            ></el-table-column>

            <el-table-column
                prop="bidLossCount"
                label="丢标条数"
                width="120"
            >
              <template slot-scope="scope">
                <div>
                  <el-button type="text" @click="lookDetailBid(scope.row,'丢标')">{{
                      scope.row.bidLossCount
                    }}</el-button>
                </div>
              </template>
            </el-table-column>

            <el-table-column
                prop="bidLossLimit"
                label="丢标额度"
                width="90"
            ></el-table-column>

            <el-table-column
                prop="bidContrast"
                label="中标率"
                width="90"
            ></el-table-column>
          </el-table-column>
          <el-table-column prop="jingpin" label="竞品信息">
            <el-table-column
                    prop="competitorsBrand"
                    label="品牌"
                    width="120"
            >
              <template slot-scope="scope">
                <div>
                  <el-button type="text" @click="lookDetailTors(scope.row)">{{
                    scope.row.competitorsBrand
                    }}</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                    prop="competitorsCategory"
                    label="品类"
                    width="90"
            ></el-table-column>
            <el-table-column
                    prop="competitorsNumber"
                    label="数量"
                    width="120"
            >
            </el-table-column>
          </el-table-column>
          <el-table-column prop="guancha" label="关差计划-留痕">
            <el-table-column
                    prop="diffAnalysis"
                    label="差异分析"
                    :show-overflow-tooltip="true"
                    width="180"
            >
              <template slot-scope="scope">
                <div>
                  <el-button type="text" @click="lookDetailDiff(scope.row)">{{
                    scope.row.diffAnalysis
                    }}</el-button>
                </div>
              </template>
            </el-table-column>
            <el-table-column
                    prop="diffStrategy"
                    label="关差策略"
                    :show-overflow-tooltip="true"
                    width="180"
            ></el-table-column>
            <el-table-column
                    prop="diffTime"
                    label="关差时间"
                    :show-overflow-tooltip="true"
                    width="120"
            >
            </el-table-column>
            <el-table-column
                    prop="personLiable"
                    :show-overflow-tooltip="true"
                    label="责任人"
                    width="90"
            ></el-table-column>
          </el-table-column>
          <el-table-column prop="status" label="用户状态" width="120">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.status == '' || scope.row.status == null"
                  >正常</span
                >
                <span v-if="scope.row.status == 1">正常</span>
                <span v-if="scope.row.status == 2">删除审批中</span>
                <span v-if="scope.row.status == 3">修改审批中</span>
                <!--                <span v-if="scope.row.status == 4">驳回审批</span>-->
                <span v-if="scope.row.status == 5">导入审批中</span>
                <span v-if="scope.row.status == 6">新增审批中</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            prop="countSign"
            label="累计跑动次数"
            width="120"
          >
            <template slot-scope="scope">
              <div>
                <el-button type="text" @click="lookDetail(scope.row)">{{
                  scope.row.countSign
                }}</el-button>
              </div>
            </template>
          </el-table-column>

          <el-table-column
              prop="agentName"
              label="签约代理商"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="yewuname"
              label="对应业务人员名称"
              width="90"
          ></el-table-column>

          <el-table-column
              prop="yewucode"
              label="对应业务人员编码"
              width="90"
          ></el-table-column>

        </el-table>
        <div class="h-tableB h-mrt30">
          <div class="h-tableBL">
            <div class="h-tableBL">
              <el-button
                class="h-btn h-formBtn h-bgblueQ"
                icon="h-el-icon h-el-icon-import"
                @click="exportExcelAll"
                >批量导出
              </el-button>
            </div>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="selectPageAll" />
          </div>
        </div>
      </div>
    </div>
    <!-- 查看累计跑动记录 -->
    <el-dialog
      title=""
      :visible.sync="runningFlag"
      :fullscreen="false"
      width="70%"
      :modal="true"
      :before-close="handleClose"
      class="h-dialog2"
    >
      <h3>&nbsp;</h3>
      <div class="tanBox">
        <el-table
          :data="tableDatahi"
          border
          max-height="420"
          style="width: 94%; margin: 0 auto"
        >
          <el-table-column label="序号" type="index" fixed width="50">
          </el-table-column>
          <el-table-column prop="userCode" label="工号" width="100">
          </el-table-column>
          <el-table-column
            prop="userName"
            label="姓名"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="createTime"
            label="签到时间"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="signOutTime"
            label="签退时间"
            width="150"
          ></el-table-column>
          <el-table-column
            prop="departmentName"
            label="科室"
            width="120"
          ></el-table-column>
          <el-table-column
            prop="deptPersonName"
            label="联系人"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="signPoint"
            label="拜访目标"
            :show-overflow-tooltip="true"
            width="100"
          ></el-table-column>
          <el-table-column
            prop="signContent"
            label="拜访记录"
            :show-overflow-tooltip="true"
            width="200"
          ></el-table-column>
          <el-table-column
              prop="signDeptName"
              label="用户单位"
              :show-overflow-tooltip="true"
              width="200"
          ></el-table-column>
        </el-table>
      </div>
      <div
        style="
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 20px;
        "
      >
        <paginationmin :page="mf" @query="handleMessage" />
      </div>
    </el-dialog>
    <!-- 漏斗详情 -->
    <el-dialog
        title=""
        :visible.sync="loudFlag"
        :fullscreen="false"
        width="70%"
        :modal="true"
        :before-close="handleClose1"
        class="h-dialog2"
    >
      <h3>&nbsp;</h3>
      <div class="tanBox">
        <el-table
            :data="tableLoud"
            border
            max-height="420"
            style="width: 94%; margin: 0 auto"
        >
          <el-table-column label="序号" type="index" fixed width="50">
          </el-table-column>
          <el-table-column
              prop="funnelCode"
              label="漏斗信息编号"
              width="140">
          </el-table-column>

          <el-table-column prop="proState" label="状态" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.proState == 1 ">
                未转化
              </span>
              <span v-if="scope.row.proState == 2 ">
                部分已转化
              </span>
              <span v-if="scope.row.proState == 3 ">
                已转化
              </span>
              <span v-if="scope.row.proState == 4 ">
                已丢标
              </span>
            </template>
          </el-table-column>

          <el-table-column prop="proState" label="漏斗来源" width="80">
            <template slot-scope="scope">
              <span v-if="scope.row.cluefrom == 1 ">
                市场录入
              </span>
              <span v-if="scope.row.cluefrom == 2 ">
                经销商录入
              </span>
              <span v-if="scope.row.cluefrom == 3 ">
                线索录入
              </span>
            </template>
          </el-table-column>

          <el-table-column
              prop="expectConvertDate"
              label="报单日期"
              :formatter="formatDate"
              width="110">
          </el-table-column>
          <el-table-column
              prop="cuname"
              label="报单人"
              :show-overflow-tooltip="true"
              width="80"
          >
          </el-table-column>
          <el-table-column
              prop="customerChannel"
              label="渠道"
              width="80"
              :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <dictname category="sales_region" :v="scope.row.customerChannel"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="areaName"
              label="区域"
              width="80"
              :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
              prop="province"
              label="销售区域"
              width="80"
              :show-overflow-tooltip="true">
          </el-table-column>
          <el-table-column
              prop="city"
              label="销售地市"
              width="100">
          </el-table-column>

          <el-table-column
              prop="probjectSorts"
              label="项目分类"
              width="110"
              :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <dictname category="message_type" :v="scope.row.probjectSorts"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="chanceTypeName"
              label="机会分类"
              width="110"
              :show-overflow-tooltip="true">

          </el-table-column>

          <el-table-column
              prop="projectName"
              label="项目名称"
              :show-overflow-tooltip="true"
              width="150">
          </el-table-column>

          <el-table-column
              prop="agentName"
              label="对阵签约经销商"
              :show-overflow-tooltip="true"
              width="150">
          </el-table-column>

          <el-table-column
              prop="salesman"
              label="销售人员"
              :show-overflow-tooltip="true"
              width="150">
          </el-table-column>
          <el-table-column
              prop="customerName"
              label="用户单位"
              :show-overflow-tooltip="true"
              width="150">
          </el-table-column>
          <el-table-column
              prop="toAddress"
              label="收货地址"
              :show-overflow-tooltip="true"
              width="150">
          </el-table-column>
          <el-table-column
              prop="deptName"
              label="科室"
              width="110">
          </el-table-column>
          <el-table-column
              prop="chargePerson"
              label="联系人/负责人"
              width="112">
          </el-table-column>
          <el-table-column
              prop="phone"
              label="电话"
              width="110">
          </el-table-column>

          <el-table-column
              prop="xsyb_lianqun"
              label="链群"
              width="110"
              :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <dictname category="xsyb_lianqun" :v="scope.row.lianqun"/>
            </template>
          </el-table-column>
          <el-table-column prop="scenesType" label="场景" width="80">
            <template slot-scope="scope">
              <dictname category="loud_scene" :v="scope.row.scenesType"></dictname>
            </template>
          </el-table-column>

          <el-table-column prop="nosignProcode" label="非标产品型号" width="105">
            <template slot-scope="scope">
              <dictname category="crm_changjing_type" :v="scope.row.nosignProcode"></dictname>
            </template>
          </el-table-column>

          <el-table-column
              prop="proModel"
              label="产品型号"
              :show-overflow-tooltip="true"
              width="150">
          </el-table-column>
          <el-table-column
              prop="proType"
              label="产品类型"
              :show-overflow-tooltip="true"
              width="100">
          </el-table-column>
          <el-table-column
              prop="proLevelOne"
              label="产品大类"
              :show-overflow-tooltip="true"
              width="150">
          </el-table-column>
          <el-table-column
              prop="proLevelTwo"
              label="产品中类"
              :show-overflow-tooltip="true"
              width="150">
          </el-table-column>

          <el-table-column
              prop="num"
              label="数量"
              width="110">
          </el-table-column>
          <el-table-column
              prop="price"
              label="价格（万）"
              width="150">
          </el-table-column>
          <el-table-column
              prop="totalPrice"
              label="金额合计"
              width="110">
          </el-table-column>
          <el-table-column
              prop="income"
              label="收入"
              width="110">
          </el-table-column>
          <el-table-column
              prop="residueNum"
              label="剩余数量"
              width="110">
          </el-table-column>
          <el-table-column
              prop="statusR"
              label="节点(项目状态)"
              width="110"
              :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <dictname category="xinxi_jiedian" :v="scope.row.statusR"/>
            </template>
          </el-table-column>
          <el-table-column
              prop="expOnlineDate"
              label="预计下单时间"
              :formatter="formatDate"
              width="110">
          </el-table-column>
          <el-table-column
              prop="weekInfos"
              label="周"
              width="50">
          </el-table-column>
          <el-table-column
              prop="expConvDate"
              label="预计转化时间"
              :formatter="formatDate"
              width="110">
          </el-table-column>
          <el-table-column
              prop="documentaryType"
              label="跟单商类别"
              width="110"
              :show-overflow-tooltip="true">
            <template slot-scope="scope">
              <dictname category="gendanshang" :v="scope.row.documentaryType"/>
            </template>
          </el-table-column>
          <!--    新加字段      -->
          <el-table-column
              prop="sapCode"
              label="关联订单号"
              width="110">
          </el-table-column>
          <el-table-column
              prop="orderstotalprice"
              label="关联订单总额"
              width="110">
          </el-table-column>
          <el-table-column
              prop="orderNumber"
              label="关联订单数量"
              width="110">
          </el-table-column>

          <el-table-column prop="status" label="漏斗状态" width="120px">
            <template slot-scope="scope">
              <div>
                <span v-if="scope.row.status == '' || scope.row.status == null || scope.row.status == 0 ">正常</span>
                <!--                <span v-if="scope.row.status == 0">正常</span>-->
                <span v-if="scope.row.status == 1">审批中</span>
                <span v-if="scope.row.status == 2">驳回审批</span>
              </div>
            </template>
          </el-table-column>

          <el-table-column
              prop="partner"
              label="合伙人名称"
              width="110">
          </el-table-column>
          <el-table-column
              prop="packageName"
              label="套餐名称"
              width="200">
          </el-table-column>
          <el-table-column
              prop="packageCode"
              label="套餐编码"
              width="110">
          </el-table-column>
        </el-table>
      </div>
      <div
          style="
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 20px;
        "
      >
        <paginationmin :page="mloud" @query="handleMessage1" />
      </div>
    </el-dialog>

    <!-- 招标详情 -->
    <el-dialog
        title=""
        :visible.sync="bidFlag"
        :fullscreen="false"
        width="70%"
        :modal="true"
        :before-close="handleClose1"
        class="h-dialog2"
    >
      <h3>&nbsp;</h3>
      <div class="tanBox">
        <el-table
            :data="tableBid"
            border
            max-height="420"
            style="width: 94%; margin: 0 auto"
        >
          <el-table-column label="序号" type="index"  width="50">
          </el-table-column>
          <el-table-column
              prop="hangingDate"
              label="挂网日期"
              width="90"
          ></el-table-column>

          <el-table-column prop="q1Target" label="基本信息">
            <el-table-column
                prop="projectName"
                label="项目名称"
                width="90"
            ></el-table-column>


            <el-table-column prop="deptName" label="用户单位" width="140" :show-overflow-tooltip="true">
              <template scope="scope">
                <div style="text-align: left">
                  {{ scope.row.deptName }}
                </div>
              </template>
            </el-table-column>
            <el-table-column
                prop="ownerContacts"
                label="业主联系人"
                width="90"
            ></el-table-column>
            <el-table-column
                prop="ownerTelephone"
                label="业主联系电话">
            </el-table-column>

            <el-table-column
                prop="agency"
                label="代理机构">
            </el-table-column>

            <el-table-column
                prop="agencyContacts"
                label="代理机构联系人"
                width="90"
            ></el-table-column>

            <el-table-column
                prop="agencyTelephone"
                label="代理机构联系方式"
                width="90"
            ></el-table-column>
          </el-table-column>
          <el-table-column prop="zhongbiao" label="中标信息">
            <el-table-column
                prop="bidChannel"
                label="渠道"
                width="90"
            ></el-table-column>
            <el-table-column
                prop="bidProductType"
                label="产品类别"
                width="90"
            ></el-table-column>
            <el-table-column
                prop="bidProduct"
                label="产品"
                width="90"
            ></el-table-column>

            <el-table-column
                prop="bidNumber"
                label="数量"
                width="90"
            ></el-table-column>

            <el-table-column
                prop="bidResult"
                label="开标结果"
                width="90"
            ></el-table-column>

            <el-table-column
                prop="bidBrand"
                label="中标品牌"
                width="90"
            ></el-table-column>

            <el-table-column
                prop="bidModel"
                label="中标型号"
                width="90"
            ></el-table-column>



            <el-table-column
                prop="bidCompany"
                label="中标公司"
                width="120"
            >
            </el-table-column>

            <el-table-column
                prop="bidTotal"
                label="中标总额(万元)"
                width="90"
            ></el-table-column>

          </el-table-column>

          <el-table-column prop="zhaobiao" label="招标信息">

            <el-table-column
                prop="tenderId"
                label="招标Id"
                width="90"
            ></el-table-column>
            <el-table-column
                prop="tenderProject"
                label="项目名称"
                width="90"
            ></el-table-column>
            <el-table-column
                prop="tenderHangingDate"
                label="挂网日期"
                width="90"
            ></el-table-column>
            <el-table-column
                prop="tenderEndDate"
                label="截止/开标日期"
                width="90"
            ></el-table-column>
            <el-table-column
                prop="tenderSubpackage"
                label="分包"
                width="90"
            ></el-table-column>

            <el-table-column
                prop="tenderIsPack"
                label="是否打包"
                width="90"
            ></el-table-column>

            <el-table-column
                prop="tenderCreate"
                label="扩建/新建"
                width="90"
            ></el-table-column>

            <el-table-column
                prop="tenderInterest"
                label="是否贴息"
                width="90"
            ></el-table-column>

          </el-table-column>
        </el-table>
      </div>
      <div
          style="
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 20px;
        "
      >
        <paginationmin :page="mbid" @query="handleMessage2" />
      </div>
    </el-dialog>

    <!-- 关差计划 -->
    <el-dialog
            title=""
            :visible.sync="diffFlag"
            :fullscreen="false"
            width="70%"
            :modal="true"
            :before-close="handleClose"
            class="h-dialog2"
    >
      <h3>&nbsp;</h3>
      <div class="tanBox">
        <el-table
                :data="tableDatadiff"
                border
                max-height="420"
                style="width: 94%; margin: 0 auto"
        >
          <el-table-column label="序号" type="index" fixed width="50">
          </el-table-column>
          <el-table-column
                  prop="deptName"
                  label="用户单位"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="diffAnalysis"
                  label="差异分析"
                  width="300"
          ></el-table-column>
          <el-table-column
                  prop="diffStrategy"
                  label="关差策略"
                  width="300"
          ></el-table-column>
          <el-table-column
                  prop="diffTime"
                  label="关差时间"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="personLiable"
                  label="责任人"
                  width="150"
          ></el-table-column>
        </el-table>
      </div>
      <div
              style="
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 20px;
        "
      >
        <paginationmin :page="diff" @query="handleMessage3" />
      </div>
    </el-dialog>

    <!-- 竞品信息 -->
    <el-dialog
            title=""
            :visible.sync="torsFlag"
            :fullscreen="false"
            width="70%"
            :modal="true"
            :before-close="handleClose4"
            class="h-dialog2"
    >
      <h3>&nbsp;</h3>
      <div class="tanBox">
        <el-table
                :data="tableTors"
                border
                max-height="420"
                style="width: 94%; margin: 0 auto"
        >
          <el-table-column label="序号" type="index" fixed width="50">
          </el-table-column>
          <el-table-column
                  prop="deptName"
                  label="用户单位"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="classifyName"
                  label="品类名称"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="brandName"
                  label="品牌名称"
                  width="300"
          ></el-table-column>
          <el-table-column
                  prop="modelName"
                  label="型号名称"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="quantity"
                  label="数量"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="areaName"
                  label="区域名称"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="province"
                  label="省份"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="city"
                  label="市"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="region"
                  label="区"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="channelName"
                  label="渠道名称"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="gatherer"
                  label="采集人"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="userCode"
                  label="采集人工号"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="purchaseTime"
                  label="采购时间"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="courtyard"
                  label="院区"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="department"
                  label="科室"
                  width="150"
          ></el-table-column>
          <el-table-column
                  prop="img"
                  label="图片"
                  width="150"
          ></el-table-column>
        </el-table>
      </div>
      <div
              style="
          display: flex;
          justify-content: flex-end;
          align-items: center;
          margin-top: 20px;
        "
      >
        <paginationmin :page="diff" @query="handleMessage4" />
      </div>
    </el-dialog>

  </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from "../../../utils/updownfile";

export default {
  data() {
    return {
      baseClass: "active", // 基础类名
      q: {
        year: "",
        scenesCode: "",
        pageNo: 1,
        pageSize: 10,
        total: 0,
        userUnitName: "",
        agentName: "",
        province: "",
      },
      qyearList: [],
      qudaoList: [],
      tableData: [],
      //表格
      multipleSelection: [],
      isjlFlag: false,
      isAdmin: false,
      shenglist: [], // 省份list
      addressTypeList: [],
      monthList:["01","02","03","04","05","06","07","08","09","10","11","12"],
      runningFlag: false, // 累计跑动详情
      loudFlag: false, // 漏斗详情
      bidFlag:false,//招标
      diffFlag:false,//关差
      torsFlag:false,//竞品
      tableDatahi: [], // 跑动详情列表
      tableLoud:[],
      tableDatadiff:[],//关差
      tableBid:[],
      tableTors:[],
      mf: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      mloud: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      mbid: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      diff: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      tors: {
        pageSize: 10,
        pageNo: 1,
        total: 0
      },
      userUnitName: '',// 当前行用户名称
      channelCode: '',// 当前行用户名称
    };
  },

  methods: {
    //表格
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 列表查询
    selectPageAll() {
      ss.grabOrderApi.selectgTopSalseQuotaPage(this.q).then((res) => {
        this.tableData = res.records;
        this.q.total = res.total;
      });
    },
    //导出
    exportExcelAll() {
      // 到处接口需要替换
      updownfile.down(
        "/api/swyl/v1/demo/bscTopUserForm/downloadExcel",
        this.q,
        "post",
        "parmea"
      );
    },
    // 重置
    rest() {
      var pageSize = this.q.pageSize;
      var pageNo = this.q.pageNo;
      var total = this.q.total;
      this.q = {
        pageSize: pageSize,
        pageNo: pageNo,
        total: total,
        year: "",
        scenesCode: "",
        userUnitName: "",
        agentName: "",
        province: "",
      };
    },
    // 查看详情
    lookDetail(val) {
      console.log(val);
      this.runningFlag = true;
      let data = {
          pageSize: 10,
          pageNo: 1,
          userUnitName: val.userUnitName
      }
      this.userUnitName = val.userUnitName
      ss.grabOrderApi.selectSignContentPage(data).then((res) => {
        this.tableDatahi = res.records;
        this.mf.total = res.total;
      });
    },
    lookDetailLoud(val){
      console.log(val);
      this.loudFlag = true;
      let data = {
        pageSize: 10,
        pageNo: 1,
        userUnitName: val.userUnitName,
        channel: val.channelCode
      }
      this.userUnitName = val.userUnitName
      this.channel = val.channelCode
      ss.grabOrderApi.selectLoudMainList(data).then((res) => {
        console.log(res);
        this.tableLoud = res.records;
        this.mloud.total = res.total;
      });
    },
    lookDetailBid(val,bidResult){
      this.bidFlag = true;
      let data = {
        pageSize: 10,
        pageNo: 1,
        userUnitName: val.userUnitName,
        bidResult: bidResult
      }
      this.userUnitName = val.userUnitName
      this.bidResult = bidResult
      ss.grabOrderApi.selectBidList(data).then((res) => {
        console.log(res);
        this.tableBid = res.records;
        this.mbid.total = res.total;
      });
    },
    //关差
    lookDetailDiff(val){
      this.diffFlag = true;
      let data = {
        pageSize: 10,
        pageNo: 1,
        userUnitName: val.userUnitName,
      }
      this.userUnitName = val.userUnitName
      ss.grabOrderApi.selectDiffListPage(data).then((res) => {
        console.log(res);
        this.tableDatadiff = res.records;
        this.diff.total = res.total;
      });
    },
    //竞品
    lookDetailTors(val){
      this.torsFlag = true;
      let data = {
        pageSize: 10,
        pageNo: 1,
        userUnitName: val.userUnitName,
      }
      this.userUnitName = val.userUnitName
      ss.grabOrderApi.selectCompetitorsListPage(data).then((res) => {
        console.log(res);
        this.tableTors = res.records;
        this.tors.total = res.total;
      });
    },
    handleMessage() {
      this.mf.userUnitName = this.userUnitName
      ss.grabOrderApi.selectSignContentPage(this.mf).then((res) => {
        this.mf.total = res.total;
        this.tableDatahi = res.records;
      });
    },
    handleMessage1() {
      this.mloud.userUnitName = this.userUnitName
      this.mloud.channel = this.channelCode
      ss.grabOrderApi.selectLoudMainList(this.mloud).then((res) => {
        this.mloud.total = res.total;
        this.tableLoud = res.records;
      });
    },

    handleMessage2() {
      this.mbid.userUnitName = this.userUnitName
      this.mbid.bidResult = this.bidResult
      ss.grabOrderApi.selectBidList(this.mbid).then((res) => {
        this.mbid.total = res.total;
        this.tableBid = res.records;
      });
    },
    handleMessage3() {
      this.diff.userUnitName = this.userUnitName
      ss.grabOrderApi.selectDiffListPage(this.diff).then((res) => {
        this.diff.total = res.total;
        this.tableDatadiff = res.records;
      });
    },
    handleMessage4() {
      this.tors.userUnitName = this.userUnitName
      ss.grabOrderApi.selectCompetitorsListPage(this.tors).then((res) => {
        this.tors.total = res.total;
        this.tabletors = res.records;
      });
    },
    //关闭弹出框
    handleClose(v) {
      this.mf.pageNo = 1;
      v();
    },
    handleClose1(v) {
      this.mloud.pageNo = 1;
      v();
    },
    handleClose3(v) {
      this.diff.pageNo = 1;
      v();
    },
    handleClose4(v) {
      this.tors.pageNo = 1;
      v();
    },
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property]
      if (data == null) {
        return null
      }
      let dt = new Date(data)
      return this.$util.riQi3(dt);
    },
    // 获取省份
    loadArea(i) {
      let proSelect = {
        pcode: 0,
        level: 1,
      };
      ss.Dictservice.arealist(proSelect).then((rd) => {
        this.shenglist = rd;
      });
    },
    // 获取渠道
    getQudaoList() {
      ss.Dictservice.listbycategory("sales_region").then((rd) => {
        this.qudaoList = rd;
      });
    },
  },
  created() {
    this.selectPageAll();
    this.getQudaoList();
    for (var i = 2024; i <= new Date().getFullYear() + 30; i++) {
      this.qyearList.push(i);
    }
    this.loadArea();
    this.q.year =new Date().getFullYear();
    this.q.month =  (new Date().getMonth()+1<10?"0"+(new Date().getMonth()+1):(new Date().getMonth()+1));// 年月
    this.isjlFlag = this.$store.getters.hasRole("swyl_quyujl,swyl_daqujl");
    this.isAdmin = this.$store.getters.hasRole("swyl_admin");
  },
  components: {},
};
</script>
<style scoped lang="less">
/deep/ .h-formbLine .el-form-item__label {
  width: 100px;
}
/deep/ .h-formbLine .el-form-item__content {
  width: 150px;
}
.active {
  color: red;
}
</style>
